import {
  TopicDistributionDataEntry,
  useTopicDistributionChart,
} from "@jugl-web/domain-resources/analytics/components/TopicDistributionWidget";
import { WidgetEmptyStateLabel } from "@jugl-web/domain-resources/analytics/components/WidgetEmptyStateLabel";
import { useTranslations } from "@jugl-web/utils";
import Highcharts from "highcharts";
import "highcharts/modules/treemap";
import HighchartsReact from "highcharts-react-official";
import { FC } from "react";
import { ReactComponent as QuestionIcon } from "./assets/question.svg";
import { WidgetContainer } from "../WidgetContainer";
import { WidgetContainerTitle } from "../WidgetContainerTitle";

export const TopicDistributionWidget: FC<{
  data: TopicDistributionDataEntry[];
}> = ({ data }) => {
  const { t } = useTranslations();
  const { chartRef, options, isEmpty } = useTopicDistributionChart(data);

  return (
    <WidgetContainer className="flex h-[660px] flex-col items-stretch gap-8">
      <WidgetContainerTitle
        icon={<QuestionIcon className="shrink-0" />}
        title={t({
          id: "cx-page.topic-distribution",
          defaultMessage: "Topic distribution",
        })}
        subtitle={t({
          id: "cx-page.topic-distribution-subtitle",
          defaultMessage: "Click on a topic to drill down",
        })}
      />
      <div className="min-h-0 w-full flex-1">
        {!isEmpty ? (
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            containerProps={{
              className: "h-full w-full",
            }}
            options={options}
          />
        ) : (
          <div className="flex h-full items-center justify-center">
            <WidgetEmptyStateLabel />
          </div>
        )}
      </div>
    </WidgetContainer>
  );
};
